import React, { useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";

import { logout, UserStore } from "$stores/user";
import { buildRedirectWithPath } from "$utils/api-helpers";
import { AppContextStore } from "$stores/app-context";

const AuthRoute = ({ component: Component, ...rest }) => {
    const auth = UserStore.useState((s) => s.isAuthed);
    const isAdmin = UserStore.useState((s) => s.isAdmin);

    const maintenanceMode = AppContextStore.useState((s) => s.maintenanceMode);

    useEffect(() => {
        if (maintenanceMode && auth && !isAdmin) {
            logout();
        }
    }, [maintenanceMode, auth, isAdmin]);

    let location = useLocation();
    const redirect = buildRedirectWithPath("/", `${location.pathname}${location.search}`);
    if (!auth) {
        return <Navigate to={redirect} state={{ from: location }} />;
    }

    return <Outlet />;
};
export default AuthRoute;
